<template>
  <div class="tab-content-one__container">
    <!-- head -->
    <div class="content__head">
      <h2 class="content__head-title">{{ baseMmaintenance.title }}</h2>
      <p class="content__head-text" v-html="$convertPxToRem(baseMmaintenance.content)"></p>
    </div>

    <!-- body -->
    <div class="content__body">
      <!-- img01 -->
      <div class="content__body__img-one"></div>

      <div class="content__body__service-box flex">
        <!-- left img -->
        <div class="content__body__service-box__item content__body__service-box__left flex f-jus-end">
          <div class="content__body__service-box__left-bg"></div>
        </div>

        <!-- right text -->
        <div class="content__body__service-box__item content__body__service-box__right">
          <!-- title -->
          <h2 class="content__body__service-box__right-title">{{ baseMmaintenance.group1.title }}</h2>
          <div v-for="(txt, i) in baseMmaintenance.group1.list" :key="i" class="content__body__service-box__right-txt flex">
            <span style="padding-right:4px;">●</span>
            <span>{{ txt }}</span>
          </div>
        </div>
      </div>

      <!-- img02 -->
      <div class="content__body__img-two"></div>

      <div class="content__foot">
        <!-- qrcode -->
        <div class="content__foot__qrcode-box flex f-jus-center">
          <div class="content__foot__qrcode-img"></div>
        </div>
        <!-- 获益列表 -->
        <div class="content__foot__rights-list flex f-jus-center">
          <div
          class="content__foot__rights-item"
          v-for="(rights, i) in baseMmaintenance.rights_list" :key="i">
            <h3 class="content__foot__rights-item__title">
              <span style="padding-right:2px;">●</span>
              <span>{{ rights.title }}</span>
            </h3>
            <p class="content__foot__rights-item__txt">{{ rights.content }}</p>
          </div>
        </div>
      </div>
    </div>
    <footer-wrap></footer-wrap>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'


export default {
  name: 'TabContentOne',

  data() {
      return {

      }
  },

  computed: {
    ...mapGetters([
      'currentLang'
    ]),
    baseMmaintenance() {
      return this.currentLang.config.customerServicePage.baseMmaintenance
    },
  },

    created() {

    },

    methods: {}
}
</script>

<style scoped lang="scss">

.content__head {
  width: 1000px;
  height: auto;
  margin: 50px auto 80px;
  text-align: center;

  h2 {
    color: #323232;
    font-weight: normal;
    margin-bottom: 30px;
    font-size: 30px;
  }

  p {
    color: #777777;
  }

  .content__head-text {
    line-height: 1.8;
    font-size: 18px;
    color: #777;
    text-align: justify;
    text-align-last: center;
  }
}


.content__body {
  .content__body__img-one {
    height: 550px;
    background: url("../../../../assets/images1/customer_service/khfw07.jpg") no-repeat scroll;
    background-position: center center;
    background-size: cover;
  }

  .content__body__service-box {
    background: #fff;
  }

  .content__body__service-box__item {
    padding: 0 90px;
    width: 50%;
    height: 470px;
  }

  .content__body__service-box__left-bg {
    margin-top: 80px;
    width: 350px;
    height: 250px;
    background: url("../../../../assets/images1/customer_service/khfw09.png") no-repeat scroll;
    background-position: center center;
    background-size: cover;
  }

  .content__body__service-box__right-title {
    margin: 120px 0 40px;
    font-weight: 500;
    letter-spacing: 1px;
    color: #0F335E;
  }

  .content__body__service-box__right-txt {
    margin-top: 12px;
    color: #777;
    line-height: 1.5;
    font-size: 18px;
  }

  .content__body__img-two {
    height: 450px;
    background: url("../../../../assets/images1/customer_service/khfw08.jpg") no-repeat scroll;
    background-position: center center;
    background-size: cover;
  }
}

.content__foot {
  width: 100%;
  height: 750px;
  background-color: #fff;

  .content__foot__qrcode-box {
    width: 100%;
    height: 550px;
  }

  .content__foot__qrcode-img {
    margin-top: 90px;
    width: 410px;
    height: 460px;
    background: url("../../../../assets/images1/customer_service/khfw10.jpg") no-repeat scroll;
    background-position: center center;
    background-size: cover;
  }

  .content__foot__rights-list {
    width: 100%;
    // padding: 0 40px;
  }

  .content__foot__rights-item {
    max-width: 250px;
    min-width: 200px;
    margin-right: 40px;
  }
  .content__foot__rights-item:last-child {
    margin-right: 0;
  }

  .content__foot__rights-item__title {
    margin-bottom: 20px;
    font-size: 22px;
    font-weight: 500;
    letter-spacing: 1px;
    color: #0F335E;
  }

  .content__foot__rights-item__txt {
    color: #777;
    line-height: 1.6;
    text-align: justify;
    font-size: 18px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/home/home_customer_service/components/TabContentOne.vue